import { useState } from "react";
import { AutoComplete } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useEnums } from "../../../hooks";
import { useTranslation } from "react-i18next";

export default function SearchBar() {
  const { enums } = useEnums();
  const [value, setValue] = useState("");
  const { t } = useTranslation();

  const [filteredResult, setFilteredResult] = useState(
    enums.map((e) => e.name),
  );

  const handleStringSearch = (value) => {
    setFilteredResult(
      enums.map((e) => e.name).filter((i) => i.includes(value)),
    );
  };

  return (
    <AutoComplete
      options={filteredResult.map(item => ({ value: item }))}
      value={value}
      allowClear
      prefix={<SearchOutlined />}
      placeholder={t("search")}
      onSearch={(v) => handleStringSearch(v)}
      notFoundContent={<div className="p-3 popover-theme">{t("not_found")}</div>}
      onChange={(v) => setValue(v)}
      onSelect={(v) => {
        const i = enums.findIndex((t) => t.name === v);
        document
          .getElementById(`scroll_enum_${i}`)
          .scrollIntoView({ behavior: "smooth" });
      }}
      className="w-full"
    />
  );
}
